module.exports = __webpack_public_path__ + "img/CMT.3952bb5e.svg";